import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class ProductForm extends Component {

  render() {
    let {errors, handleSubmit, submit, groups, products, currencies, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let currencyFields = currencies.map(currency => {
      return (
        <Field 
          key={currency}
          label={currency}
          name={`pricing[${currency}]`}
          serverError={this.props.errors.pricing}
          component={TextInputField}
          normalize={numerical}
          />
      )
    });

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Product"
              name="productSku"
              component={DropDownInputField}
              data={products}
              groups={groups}
              valueKey="sku"  
              titleKey="title" 
              groupKey="type"
              useGroups={true}
              showBlank={true}
              serverError={this.props.errors.productSku}
              />
            {currencyFields}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ProductForm"
})(ProductForm);

export default ReduxForm;